import { PlayBadgeSize } from '@ui-components/PlayBadge';
import { Badge } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import { StyledBadge } from './LiveBadge.styles';

type Props = {
    badge: Badge;
    size: PlayBadgeSize;
};

const LiveBadge = ({ badge, size }: Props): JSX.Element => (
    <StyledBadge text={badge.text} theme={badge.type} accessibilityText={badge.altText} overlay size={size} />
);

export default LiveBadge;
